<script setup lang="ts">
import { MtdButton, MtdModalMobile, MtdTypography } from '@paygine/mtd-uikit'

import { AttentionIcon } from '@/shared/icons'
</script>

<template>
    <MtdModalMobile>
        <template #content>
            <AttentionIcon />

            <MtdTypography
                variant="header-2"
                class="default-layout__title mt-16"
                tag="h1"
                >Не удалось подключить <br />
                выбранный банк
            </MtdTypography>

            <MtdTypography
                tag="p"
                variant="body-2"
                class="default-layout__subtitle"
                >Попробуйте другой способ оплаты</MtdTypography
            >

            <MtdButton
                class="mt-24"
                variant="main-secondary"
                >Выбрать другой способ</MtdButton
            >
        </template>
    </MtdModalMobile>
</template>
